import { queryOptions } from '@tanstack/react-query';
import type { User } from '@/common/user';
import { axios } from '@/lib/utils/axios';
import type { Pagination } from '../../common/pagination';
import { getResponse } from '../common';
import { API_URLS } from '../query.client';

export type GetListUsersSuccessResponse = {
	users: User[];
	total: number;
	page: number;
	limit: number;
};

export type GetListUsersFilters = {
	organizationId?: string;
	/** Allowlisted `field:asc|desc` pairs, see USER_SORT_FIELDS in the backend DTO. */
	sort?: string;
} & Pagination;

async function listUsers(filters: GetListUsersFilters): Promise<GetListUsersSuccessResponse | null> {
	const response = await axios(`${API_URLS.USERS.INDEX}`, {
		params: filters,
	});
	return getResponse<GetListUsersSuccessResponse>(response.data);
}

export function getListUsersOptions(filters: GetListUsersFilters = { limit: 10, offset: 0 }) {
	return queryOptions({
		queryKey: ['users', 'list', filters],
		queryFn: () => listUsers(filters),
	});
}
